angular.module('impactx.favorites').service('FavoritesService', FavoritesService);

FavoritesService.$inject = ['dataGen', '$mdToast', '$route', '$location'];

function FavoritesService(dataGen, $mdToast, $route, $location) {

    this.add = function (product) {
        var dataObj = {
            id: product.id
        };
        var tempScope = {};
        dataGen.postAsForm(tempScope, dataObj, "/favorite/add").then(function () {
            product.isFavorite = true;
            $mdToast.show(
                $mdToast.simple()
                    .textContent(tempScope.trns.success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.remove = function (product) {
        var dataObj = {
            id: product.id
        };
        var tempScope = {};
        dataGen.postAsForm(tempScope, dataObj, "/favorite/remove").then(function () {
            if ($location.path() == '/favorite') {
                $route.reload();
            }
            product.isFavorite = false;

            $mdToast.show(
                $mdToast.simple()
                    .textContent(tempScope.trns.success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    }
}